import { Box } from '@chakra-ui/react';
import React from 'react';

const Divider: React.FC = ({ ...rest }) => {
  return <Box h='0.4px' w='full' my={2} borderStyle='dashed' border='1px' {...rest} />;
};

export default Divider;
